export const ProfileTabsMobile = ({ section, athlete, query, classNames }) => {
  const organizationCoach = query.organizationCoach || undefined;

  return (
    <div className="mobile-profile-tab">
      <ul role="toggle-links" classNames={classNames}>
        <li className={section === "dashboard" ? "active" : ""}>
          <a
            data-button-type={
              section === "dashboard" ? "outline" : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=dashboard&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=dashboard&athlete=${athlete._id}`
            }
          >
            Dashboard
          </a>
        </li>
        <li className={section === "coachvideos" ? "active" : ""}>
          <a
            data-button-type={
              section === "coachvideos" ? "outline" : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=coachvideos&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=coachvideos&athlete=${athlete._id}`
            }
          >
            Coach Videos
          </a>
        </li>
        <li className={section === "questionnaire" ? "active" : ""}>
          <a
            data-button-type={
              section === "questionnaire" ? "outline" : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=questionnaire&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=questionnaire&athlete=${athlete._id}`
            }
          >
            Check-in Questionnaire
          </a>
        </li>
        <li className={section === "accountability" ? "active" : ""}>
          <a
            data-button-type={
              section === "accountability" ? "outline" : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=accountability&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=accountability&athlete=${athlete._id}`
            }
          >
            Daily Accountability
          </a>
        </li>
        <li className={section === "tasks" ? "active" : ""}>
          <a
            data-button-type={section === "tasks" ? "outline" : "text-white"}
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=tasks&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=tasks&athlete=${athlete._id}`
            }
          >
            Tasks
          </a>
        </li>
        <li className={section === "guides" ? "active" : ""}>
          <a
            data-button-type={section === "guides" ? "outline" : "text-white"}
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/profile?section=guides&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/profile?section=guides&athlete=${athlete._id}`
            }
          >
            Guides
          </a>
        </li>
      </ul>
    </div>
  );
};
